import { render } from "./Contact.vue?vue&type=template&id=65ecd870"
const script = {}

import "./Contact.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script